import { defineStyleConfig } from '@chakra-ui/system';

export const Breadcrumb = defineStyleConfig({
    baseStyle: {
        list: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: '0.25rem',
        },
    },
});
